package com.macrofocus.common.format

abstract class AbstractFormat<T> : CPFormat<T> {
    override fun format(value: T): String? {
        return formatHtml(value, false)
    }

    override val pattern: String?
        get() = null

    override fun getClassName(value: T): String? {
        return null
    }

    override val horizontalAlignment: CPFormat.HorizontalAlignment
        get() = CPFormat.HorizontalAlignment.Left
}